import { render, staticRenderFns } from "./couponListPopup.vue?vue&type=template&id=92304022&scoped=true&"
import script from "./couponListPopup.vue?vue&type=script&lang=ts&"
export * from "./couponListPopup.vue?vue&type=script&lang=ts&"
import style0 from "./couponListPopup.vue?vue&type=style&index=0&id=92304022&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92304022",
  null
  
)

export default component.exports